import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "input"]

  connect() {
    this._onKeydown = this._onKeydown.bind(this)
    this._onGlobalKeydown = this._onGlobalKeydown.bind(this)
    this._onOpenEvent = () => this.open()
    window.addEventListener("nav-search:open", this._onOpenEvent)
    document.addEventListener("keydown", this._onGlobalKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
    document.removeEventListener("keydown", this._onGlobalKeydown)
    window.removeEventListener("nav-search:open", this._onOpenEvent)
    document.body.style.overflow = ""
  }

  open(event) {
    // Stop propagation so the click doesn't bubble to document and trigger
    // autocomplete-search's closeDropdown handler before suggestions appear
    if (event?.type === "click") event.stopPropagation()
    this.overlayTarget.classList.remove("hidden")
    // Focus sync before rAF — required for iOS/Android keyboard
    if (this.hasInputTarget) this.inputTarget.focus()
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.overlayTarget.classList.remove("opacity-0")
        this.overlayTarget.classList.add("opacity-100")
        const card = this.overlayTarget.querySelector("[data-card]")
        if (card) {
          card.classList.remove("scale-95", "-translate-y-2")
          card.classList.add("scale-100", "translate-y-0")
        }
      })
    })
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this._onKeydown)
  }

  close() {
    this.overlayTarget.classList.remove("opacity-100")
    this.overlayTarget.classList.add("opacity-0")
    const card = this.overlayTarget.querySelector("[data-card]")
    if (card) {
      card.classList.remove("scale-100", "translate-y-0")
      card.classList.add("scale-95", "-translate-y-2")
    }
    setTimeout(() => this.overlayTarget.classList.add("hidden"), 200)
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this._onKeydown)
    // Clear input value only — no input event, avoids triggering autocomplete re-render
    if (this.hasInputTarget) this.inputTarget.value = ""
  }

  closeOnBackdrop(event) {
    if (!event.target.closest("[data-card]")) this.close()
  }

  _onKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  _onGlobalKeydown(event) {
    if (event.key === "f" && (event.metaKey || event.ctrlKey)) {
      const active = document.activeElement
      const inInput = active && (active.tagName === "INPUT" || active.tagName === "TEXTAREA" || active.isContentEditable)
      if (!inInput) {
        event.preventDefault()
        this.open()
      }
    }
  }
}
